import React from "react";
import { FormComponent } from "../../../components/form/DynamicForm";
import { Form, Validators } from "../../../components/form/DynamicFormTs";
import { withRouter } from "react-router-dom";
import Http from "../../../Http";
import { objectAsParams } from "../../../helpers";

class NuevoSeguimiento extends FormComponent {
  initial = true;

  componentDidMount() {
    let fields = [
      Form.Field(
        "select",
        "id_tipo_seguimiento",
        "Tipo Seguimiento",
        "",
        [Validators.required],
        12
      ),
      Form.Field("checkbox", "finalizado", "Finalizado", "", [], 6),
      Form.Field(
        "date-hour",
        "fecha_proximo_seguimiento",
        "Fecha Proximo Seguimiento",
        null,
        [],
        6
      ),
      Form.Field(
        "textarea",
        "comentario",
        "Agregar Comentario",
        "",
        [Validators.required],
        12
      ),
    ];
    if (this.props.mode !== "create") {
      fields = [
        Form.Field("checkbox", "finalizado", "Finalizado", "", [], 4),
        Form.Field(
          "date-hour",
          "fecha_proximo_seguimiento",
          "Fecha Proximo Seguimiento",
          null,
          [],
          8
        ),
        Form.Field(
          "textarea",
          "comentario",
          "Agregar Comentario",
          "",
          [Validators.required],
          12
        ),
      ];
    }
    this.FormConfig(
      {
        defaultUrl: "banco",
        saveUrl: "banco/save",
        backUrl: "/Guias/SeguimientoGuias",
      },
      new Form(fields, ["Guardar"], ""),
      this.formData
    );
    this.setState({ id_guia: false, busquedaGuias: [] });
  }

  formData = async (form) => {
    const params = {};
    let newForm = form;
    if (this.formGuia) {
      params["guia"] = this.formGuia;
      this.formGuia = null;
    }
    if (this.initial) {
      params.initial = this.initial;
      this.initial = false;
    }

    const Res = await Http.get(
      `guia-comentario/form?${objectAsParams(params)}`
    );
    if (!Res.error) {
      const { guias, tipos_seguimiento } = Res.data;
      if (guias) {
        newForm = Form.FieldOptions(newForm, "id_guia", guias, "id", "g_folio");
        this.setState({ busquedaGuias: guias });
      }
      if (tipos_seguimiento) {
        newForm = Form.FieldOptions(
          newForm,
          "id_tipo_seguimiento",
          tipos_seguimiento,
          "id",
          "tipo_seguimiento_guia"
        );
      }
    }
    newForm = Form.ValueChange(newForm, {
      id_guia: async (field) => {
        field.ValueAt &&
          field.ValueAt.length > 2 &&
          this.guiasChange(field, "formGuia");
      },
      finalizado: async (field) => {
          this.finalizadoChange(field);
      },
    });
    return newForm;
  };

  guiasChange = async (field, variable) => {
    const { busquedaGuias, id_guia, FormData } = this.state;
    let newFormData = FormData;
    if (id_guia !== field.Value) {
      const infoGuia = busquedaGuias.find(opt => `${opt.id}` === `${field.Value}`);
      if (infoGuia) {
        console.log({ infoGuia })
        newFormData = Form.Patch(
          newFormData,
          { ...infoGuia },
          false
        );
      }
      this.setState({ id_guia: field.Value });
    }
    this[variable] = field.ValueAt;
    this.setState({ FormData: await this.formData(newFormData) });
  };

  finalizadoChange = async (field, variable) => {
    const { FormData } = this.state;
    let newFormData = FormData;
    if (field.Value === true) {
      newFormData = Form.FieldMod(newFormData, 'fecha_proximo_seguimiento', 'Value', null);
      newFormData = Form.FieldMod(newFormData, 'fecha_proximo_seguimiento', 'Type', 'hidden');
    } else if(field.Value === false) {
      newFormData = Form.FieldMod(newFormData, 'fecha_proximo_seguimiento', 'Value', new Date());
      newFormData = Form.FieldMod(newFormData, 'fecha_proximo_seguimiento', 'Type', 'date-hour');
    }
    this.setState({ FormData: newFormData });
  };

  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    let Res = false;
    vals.id_guia = this.props.guia.id;
    if (this.props.mode === "create") {
      Res = await Http.post(`guia-seguimiento/save-seguimiento`, vals);
    } else {
      vals.id_seguimiento = this.props.guia.id_seguimiento;
      Res = await Http.post(`guia-comentario/save-comentario`, vals);
    }

    if (!Res.error) {
      this.setState({ loading: false, sbMsg: "Guardado", sbOpen: true });
      this.props.onSave();
    } else {
      this.setState({
        loading: false,
        sbMsg: `Error al guardar${Res.errMsg ? `: ${Res.errMsg}` : ""}`,
        sbOpen: true,
      });
    }
  };


  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    );
  }
}

export default withRouter(NuevoSeguimiento);
